import React, { Component } from 'react';
import withEhsPageBehavior from '../../withEhsPageBehavior';
import GroupApi from '../../api/group';
import Subnav from '../subnav';
import Button from '../form/Button';

class ManagePracticesPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {};
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    onEmailChange(evt) {
        let emailVal = evt.target.value;
        this.setState({
            email: emailVal,
        });
    }
    async onClick() {
        const email = this.state.email.toLowerCase();
        await GroupApi.postPurchaseNewConsultant(email)
            .then(() => {
                console.log('Success! Added ' + email);
                alert('Success! Added ' + email);
            })
            .catch(err => {
                console.log(err);
                alert('Error: ' + err);
            });
    }
    render() {
        return (
            <main className="page">
                <div className="page__subnav">
                    <Subnav />
                </div>
                <div className="page__header">
                    <label for="emailField">Email:</label>
                    <input type="text" name="emailField" value={this.state.email} onChange={this.onEmailChange} />
                    <Button onClick={this.onClick} defaultText="Submit" icon="fa-sign-in"></Button>
                </div>
            </main>
        );
    }
}

export default withEhsPageBehavior(ManagePracticesPage);
